'use client';

import { c as _c } from "react/compiler-runtime";
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@material-bank/mb3-components';
import { useTranslations } from '@material-bank/i18n';
import { useComingSoonDrawer } from './ComingSoonDrawerProvider';
import { useOverlayThemeColor } from '../../hooks/useOverlayThemeColor';
import { DrawerDragHandle } from '../DrawerDragHandle/DrawerDragHandle';
import { ComingSoonDrawerContent } from './ComingSoonDrawerContent';
export function ComingSoonDrawer() {
  const $ = _c(20);
  const {
    isOpen,
    close
  } = useComingSoonDrawer();
  useOverlayThemeColor(isOpen);
  const t = useTranslations("comingSoon");
  let t0;
  if ($[0] !== close) {
    t0 = function openChangeHandler(open) {
      if (!open) {
        close();
      }
    };
    $[0] = close;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const openChangeHandler = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("title");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <DrawerTitle className="sr-only">{t1}</DrawerTitle>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("description");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <DrawerDescription className="sr-only">{t3}</DrawerDescription>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DrawerDragHandle />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== close || $[12] !== isOpen) {
    t6 = <DrawerContent className="max-h-[85vh] rounded-t-[20px] flex flex-col [&>div:first-child]:hidden">{t5}<ComingSoonDrawerContent isOpen={isOpen} close={close} /></DrawerContent>;
    $[11] = close;
    $[12] = isOpen;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isOpen || $[15] !== openChangeHandler || $[16] !== t2 || $[17] !== t4 || $[18] !== t6) {
    t7 = <Drawer open={isOpen} onOpenChange={openChangeHandler}>{t2}{t4}{t6}</Drawer>;
    $[14] = isOpen;
    $[15] = openChangeHandler;
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}